module.exports = {
  copySync: require('./copy-sync')
}



//////////////////
// WEBPACK FOOTER
// ./~/swarm-js/~/fs-extra/lib/copy-sync/index.js
// module id = 748
// module chunks = 0 1 3